import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const CalendarWidget = (props) => {
  const { month, year, daysWithData, selectedDay, selectedDayOnChange } = props;
  const daysToMark = Object.keys(daysWithData || {});
  const wrapperRef = useRef(null);

  //set selected day to 0 if user clicks outside of table
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        selectedDayOnChange(0);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  let firstDay = new Date(year, month).getDay();
  let daysInMonth = 32 - new Date(year, month, 32).getDate();
  let date = 1;
  let rows = [];
  for (let i = 0; i < 6; i++) {
    // creates a table row
    let row = [];
    //creating individual cells, filing them up with data.
    for (let j = 0; j < 7; j++) {
      if (i === 0 && j < firstDay) {
        row.push("");
      } else if (date > daysInMonth) {
        break;
      } else {
        row.push(date);
        date++;
      }
    }
    rows.push(row); // appending each row into calendar body.
  }
  return (
    <table className="text-neutral-600" id="calendar">
      <thead>
        <tr className="text-center">
          <th className="text-base font-bold w-14">Su</th>
          <th className="text-base font-bold w-14">Mo</th>
          <th className="text-base font-bold w-14">Tu</th>
          <th className="text-base font-bold w-14">We</th>
          <th className="text-base font-bold w-14">Th</th>
          <th className="text-base font-bold w-14">Fr</th>
          <th className="text-base font-bold w-14">Sa</th>
        </tr>
      </thead>
      <tbody id="calendar-body" ref={wrapperRef}>
        {rows.map((row, index) => {
          return (
            <tr key={`row-${index}`}>
              {row.map((day, index) => {
                return (
                  <td
                    className={`text-lg font-semibold text-center relative p-1 ${
                      daysToMark.includes(day.toString())
                        ? " cursor-pointer"
                        : ""
                    }`}
                    key={`td${index}`}
                    onClick={() => selectedDayOnChange(day || 0)}
                    onMouseEnter={() => selectedDayOnChange(day || 0)}
                    onMouseLeave={() => selectedDayOnChange(0)}
                  >
                    {daysToMark.includes(day.toString()) && (
                      <div>
                        {/* Badge */}
                        <div className="z-10 absolute top-2 right-2 bg-primary-500 rounded-full w-2 h-2 text-white text-xs flex justify-center items-center" />
                        <div
                          className={`${
                            selectedDay === day ? "" : "hidden"
                          } absolute z-50`}
                          style={
                            index > 3
                              ? { right: "50px" }
                              : index === 3
                                ? { top: "38px", left: "-50px" }
                                : { left: "50px" }
                          }
                        >
                          {daysWithData[day.toString()].map((item, index) => (
                            <div
                              key={index}
                              className="z-20 bg-neutral-100 text-xs p-2"
                            >
                              <div>{item}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {day}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const calendarWidgetControls = {
  month: {
    propType: PropTypes.number,
    description: "Current month (0-11)",
    controlType: "number",
    min: 0,
    max: 11,
    defaultValue: new Date().getMonth(),
  },
  year: {
    propType: PropTypes.number,
    description: "Current year",
    controlType: "number",
    defaultValue: new Date().getFullYear(),
  },
  daysWithData: {
    propType: PropTypes.object,
    description: "Object marking days with data (e.g., {1: true, 15: true})",
    controlType: "object",
    defaultValue: {},
  },
  selectedDay: {
    propType: PropTypes.number,
    description: "Currently selected day",
    controlType: "number",
    min: 1,
    max: 31,
  },
  selectedDayOnChange: {
    propType: PropTypes.func,
    description: "Handler for day selection",
    disable: true,
  },
};

CalendarWidget.propTypes = AppUtils.getPropTypeFromControls(
  calendarWidgetControls,
);

export default CalendarWidget;
